import type { PortfolioFilters } from '@/stores/framework';
import {
    DeliverableState,
    ProjectState,
    ProjectStatus,
    type RoleInput,
    type NeedInput,
} from '@/gql/graphql';
import isEqualWith from 'lodash.isequalwith';

export const filterParsers: {
    [K in keyof PortfolioFilters]: (
        v: string
    ) => PortfolioFilters[K][number] | null;
} = {
    projectStatus: (v) =>
        (Object.values(ProjectStatus) as string[]).includes(v)
            ? (v as ProjectStatus)
            : null,
    projectState: (v) =>
        (Object.values(ProjectState) as string[]).includes(v)
            ? (v as ProjectState)
            : null,
    deliverableState: (v) =>
        (Object.values(DeliverableState) as string[]).includes(v)
            ? (v as DeliverableState)
            : null,
    programs: (v) => v,
    themes: (v) => v,
    projectManagers: (v) => v,
    departments: (v) => v,
    tagValues: (v) => v,
};

export function portfolioFiltersAreEqual(
    value?: PortfolioFilters,
    other?: PortfolioFilters
) {
    const customizer = (objValue: unknown, otherValue: unknown) => {
        if (Array.isArray(objValue) && Array.isArray(otherValue)) {
            return isEqualWith([...objValue].sort(), [...otherValue].sort());
        }
    };

    return isEqualWith(value, other, customizer);
}

export function seededNeeds(): InsertPortfolioRowsInput['need'] {
    return [1, 2, 3].map(
        (n, i): NeedInput => ({
            name: `Need`,
            position: i,
            group: {
                name: `Group ${n}`,
                position: i,
            },
            driver: {
                name: `Driver ${n}`,
                position: i,
            },
        })
    );
}

export function seededRoles(): InsertPortfolioColumnsInput['role'] {
    return [1, 2, 3].map(
        (role): RoleInput => ({
            name: `Role ${role}`,
            position: role,
            action: [1, 2, 3].map((action) => ({
                name: `Role ${role} - action ${action}`,
                focus: {
                    name: `Role ${role} - action ${action} - focus`,
                },
            })),
        })
    );
}
